// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"403":"31376bbc","487":"30667a58","690":"e2df290b","959":"92c7ab04"}[chunkId] + ".chunk.css";
};